// removed by extract-text-webpack-plugin
module.exports = {"root":"_3n1O6","title":"_gmmw-","container":"_1-Lqk","channelBlock":"_1cr1m","latestPostBlock":"_1w3o3"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Home/Home.scss
// module id = 1132
// module chunks = 2